import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const About = ({organizer}) => {
  return (
    <section className="company-second">
      <div className="container">
        <div className="row mt-5">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="embed-responsive embed-responsive-16by9 mb-4 mt-2" style={{borderRadius: '5px'}}>
              <iframe className="embed-responsive-item" src={organizer.linkVideo} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <p style={{fontSize: '23px',fontWeight: '600'}}>Tentang Penyelenggara</p>
            <p style={{fontSize: '13px', marginTop: '20px', lineHeight: '25px'}}>{ReactHtmlParser(organizer.about)} </p>
          </div>
        </div>
        <p style={{fontSize: '13px', marginTop: '10px', lineHeight: '25px'}}>{ReactHtmlParser(organizer.about2)} </p>
      </div>
    </section>
  )
}

export default About